
import React from 'react'
import Container from 'react-bootstrap/Container';
 import Row from 'react-bootstrap/Row';
 import Col from 'react-bootstrap/Col';
 
function Gift() {
  return (
    <div>
<Container>
      <Row style={{gap:"50px", marginTop:"50px"}}>
        <Col style={{height:"344px",width:"100%",borderRadius:"6px",boxShadow: "0 0.9em 2.8em rgba(80, 66, 0, 0.3)",backgroundColor:"#FFFFFF"}}>
       <div className="amount" style={{display:"flex" ,gap:"15px",marginTop:"30px",marginLeft:"13px"}}>
        <div style={{backgroundColor:"#693D97",height:"40px",width:"40px",borderRadius:"50%",fontSize:"16px",color:"white",display:"flex",justifyContent:"center",alignItems:"center"}} > <span >1</span></div>
        <h1 style={{fontSize:"19.5px",textAlign:"left",marginTop:"5px"}}> Amount  <small>(In PKR)</small></h1></div>
     <hr style={{marginLeft:"20px",marginRight:"20px"}} className='my-3 ' />
        
      <div className="j" style={{display:"flex"}}>
        <div className="j1"><img  style={{height:"227px",width:"170px"}} src="https://giftkarte.com/uploads/vendors/202311141339PoweredByJDot.png"/>
        </div>
        <div className="j2">
        <div style={{display: "flex",gap:"20px"}}>
 <div style={{height:"auto",width:"auto",border:"1px solid black",borderRadius:"5px",padding:"5px"}}>1,000</div>
 <div style={{height:"auto",width:"auto",border:"1px solid black",borderRadius:"5px",padding:"5px"}}>3,000</div>
 <div style={{height:"auto",width:"auto",border:"1px solid black",borderRadius:"5px",padding:"5px"}}>5,000</div>
 <div style={{height:"auto",width:"auto",border:"1px solid black",borderRadius:"5px",padding:"5px"}}>10,000</div>
 <div style={{height:"auto",width:"auto",border:"1px solid black",borderRadius:"5px",padding:"5px"}}>20,000</div>
</div>
<div className="good">
<p  style={{color:"#A7AEB8",fontSize:"16px"}}>or Enter Your Amount</p>
 <input style={{width:"355px",height:"45px" ,borderRadius:"5px",}} type="number" name="price"  data-min="1000"  placeholder="Amount"></input>
 <button  type="button" class="btn btn-light btn-sm mt-2">
<span class="w-10"><i class="fa-solid fa-calculator"></i></span>
&nbsp;
Currency Calculator
</button>
 </div>
        </div>

      
      </div> {/* j2 end */}


        </Col>
         <Col style={{height:"300px",width:"100%",borderRadius:"6px",boxShadow: "0 0.9em 2.8em rgba(80, 66, 0, 0.3)",backgroundColor:"#FFFFFF"}}> 
         <div className="amount" style={{display:"flex" ,gap:"15px",marginTop:"30px",marginLeft:"13px"}}>
        <div style={{backgroundColor:"#693D97",height:"40px",width:"40px",borderRadius:"50%",fontSize:"16px",color:"white",display:"flex",justifyContent:"center",alignItems:"center"}} > <span >2</span></div>
        <h1 style={{fontSize:"19.5px",textAlign:"left",marginTop:"5px"}}> Amount  <small>(In PKR)</small></h1></div>
     <hr style={{marginLeft:"20px",marginRight:"20px",}} className='my-3 ' />
     <Container><Row>
      <Col> <label htmlFor="">Your Name:</label>
     <div class="form-group">
    <input  type="text" name="" class="form-control" id="" placeholder="Your Name *" />
                                </div>
                                <br />
    <label htmlFor="">Country Code</label>
    <br />
    <select name="sender_country_code" class="" style={{width:"100%",height:"40px"}}>
                                                        <option selected="" value="92">Pakistan (+92)</option>
                                                        <option value="93">Afghanistan (+93)</option>
                                                        <option value="260">Zambia (+260)</option>
                                                        <option value="263">Zimbabwe (+263)</option>
                                                    </select>      
  </Col>
      <Col>
      <label htmlFor="" > Your Email Address</label>
      <div class="form-group">
      <input  style={{width:"100%",height:"40px"}} type="email" name="email"  class="form-control" id="" placeholder="Your Email *" /></div>
      <br />
      <label htmlFor="">Mobile NO.(Without Code):</label>
<input style={{width:"100%",height:"40px"}} placeholder="Mobile No."  type="number"></input>
   
      
      
      </Col>
      </Row></Container>
    
         
         </Col>
        
        
        
         
      </Row>
    </Container>
   
    <Col style={{height:"300px",width:"44%",borderRadius:"6px", marginTop:"50px",marginLeft:"52%",boxShadow: "0 0.9em 2.8em rgba(80, 66, 0, 0.3)",backgroundColor:"#FFFFFF"}}> 
    <div className="amount" style={{display:"flex" ,gap:"15px",marginLeft:"13px",paddingTop:"25px"}}>
        <div style={{backgroundColor:"#693D97",height:"40px",width:"40px",borderRadius:"50%",fontSize:"16px",color:"white",display:"flex",justifyContent:"center",alignItems:"center"}} > <span >2</span></div>
        <h1 style={{fontSize:"19.5px",textAlign:"left",marginTop:"5px"}}>Your Friend / Relative(Gift Receiver) Detail</h1>
        </div>
        <p style={{textAlign:"left",marginLeft:"60px",fontSize:"12px"}}>(Optional)</p>

     <hr style={{marginLeft:"20px",marginRight:"20px",}} className='my-3 ' />
     <Container><Row>
      <Col> <label htmlFor="">Receiver Name:</label>
     <div class="form-group">
    <input  type="text" name="" class="form-control" id="" placeholder="Name *" />
                                </div>
                                <br />
    <label htmlFor="">Receiver Country Code</label>
    <br />
    <select name="sender_country_code" class="" style={{width:"100%",height:"40px"}}>
                                                        <option selected="" value="92">Pakistan (+92)</option>
                                                        <option value="93">Afghanistan (+93)</option>
                                                        <option value="260">Zambia (+260)</option>
                                                        <option value="263">Zimbabwe (+263)</option>
                                                    </select>      
  </Col>
      <Col>
      <label htmlFor="" > Receiver Email </label>
      <div class="form-group">
      <input  style={{width:"100%",height:"40px"}} type="email" name="email" class="form-control" id="" placeholder=" Email *" /></div>
      <br />
      <label htmlFor="">Receiver Mobile NO:</label>
<input style={{width:"100%",height:"40px"}} placeholder="Mobile No."  type="number"></input>
   
      
      
      </Col>
      </Row></Container>
    </Col>
    <br />
    <br />
    <br />
    <Container><Row>
      <Col> 
      <button style={{backgroundColor:"#693D97",height:"50px",width:"auto",borderRadius:"15px",color:"white",fontSize:"16px"}} type="submit" class="btn-add-to-cart btn btn-lg btn-theme d-inline-flex align-items-center">
                                        <div class="btn-text">
                                            Proceed to Checkout
                                            <i class="ms-1" data-feather="arrow-right"></i>
                                        </div>

                                        <div class="btn-loading d-none">
                                            <div class="spinner-border spinner-border-sm text-white" role="status">
                                            </div>
                                            Please Wait ..
                                        </div>
                                    </button>      </Col>
      </Row></Container>
      <br />
      <br />
    </div>
  )
}

export default Gift
